import * as React from "react"
import PropTypes from "prop-types"

import * as S from './styles';

export default function Separator({ text }) {
  return (
    <S.Container>
      <h2>{text}</h2>
    </S.Container>
  )
}

Separator.propTypes = {
  text: PropTypes.any,
}

Separator.defaultProps = {
  text: ``,
}